
const INITIAL_STATE = {
    drawer:false,
    snackbar:false
}

export default (state = INITIAL_STATE, action) =>{
    switch (action.type) {
        case 'SETSYSTEM':{
            return {
                ...state,
                ...action.payload
            };
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/systemReducer.js